import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  alert: {
    width: '100%',
  },
  progressBar: {
    marginTop: theme.spacing(1),
  },
  counter: {
    display: 'block',
    marginTop: theme.spacing(0.5),
  },
}))

export default useStyles
